import List from 'components/List';
import React, { useState } from 'react';

export default function FAQ({ questions, type }) {
    const [selectedQuestion, setSelectedQuestion] = useState()

    return (
        <div className="container py-[48px]">
            <div className='mb-[48px] sm:mb-[64px] text-center'>
                <h1 className="text-dark text-30 sm:text-36 font-altone_b leading-[30px] sm:leading-[44px] mb-[20px]">Frequently asked questions</h1>
                <p className="text-18 sm:text-20 text-[#667085] font-dmsans_r leading-[28px] sm:leading-[30px] mb-[48px]">{`Everything you need to know about ${type}`}</p>
            </div>
            <div className='w-full'>
                {questions.map((item) =>
                    <List
                        key={item.id}
                        item={item}
                        setSelectedQuestion={setSelectedQuestion}
                        selectedQuestion={selectedQuestion}
                    />
                )}
            </div>
        </div>
    );
};
